const CORRELATION_ID_HEADER = 'x-correlation-id';
const CORRELATION_ID_STORAGE_KEY = 'x-correlation-id';

const getStoredCorrelationId = () => sessionStorage.getItem(CORRELATION_ID_STORAGE_KEY);

const clearCorrelationId = () => {
  sessionStorage.removeItem(CORRELATION_ID_STORAGE_KEY);
};

const storeCorrelationIdFromHeaders = (headers) => {
  if (!headers) {
    return;
  }
  const correlationId = headers[CORRELATION_ID_HEADER];
  if (correlationId) {
    sessionStorage.setItem(CORRELATION_ID_STORAGE_KEY, correlationId);
  }
};

const attachCorrelationIdHeader = (headers = {}) => {
  const correlationId = getStoredCorrelationId();
  if (correlationId) {
    headers[CORRELATION_ID_HEADER] = correlationId;
  }
  return headers;
};

export {
  CORRELATION_ID_HEADER,
  CORRELATION_ID_STORAGE_KEY,
  getStoredCorrelationId,
  clearCorrelationId,
  storeCorrelationIdFromHeaders,
  attachCorrelationIdHeader
};
